import { render, staticRenderFns } from "./ShowDragBox.vue?vue&type=template&id=2616c6de&scoped=true"
import script from "./ShowDragBox.vue?vue&type=script&lang=js"
export * from "./ShowDragBox.vue?vue&type=script&lang=js"
import style0 from "./ShowDragBox.vue?vue&type=style&index=0&id=2616c6de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616c6de",
  null
  
)

export default component.exports